export default "__VITE_ASSET__BeUzZuZU__"